// Learning Center — sidebar filter behavior.
// Clicking a sidebar link (or a tile) hides/shows category groups.
// "All topics" (empty data-lc-nav) shows everything.

(() => {
  const root = document.querySelector('[data-lc]');
  if (!root) return;

  const navLinks = root.querySelectorAll('[data-lc-nav]');
  const tiles = root.querySelectorAll('[data-lc-tile]');
  const groups = root.querySelectorAll('[data-lc-group]');

  const activate = (key) => {
    // key === '' means "All"
    groups.forEach((g) => {
      const gkey = g.getAttribute('data-lc-group');
      g.style.display = !key || gkey === key ? '' : 'none';
    });
    navLinks.forEach((a) => {
      const akey = a.getAttribute('data-lc-nav') || '';
      a.classList.toggle('is-active', akey === (key || ''));
    });
  };

  const readHash = () => {
    const h = (location.hash || '').replace(/^#/, '');
    if (!h || h === 'all') return '';
    if (h.startsWith('cat-')) return h.slice(4);
    return '';
  };

  navLinks.forEach((a) => {
    a.addEventListener('click', () => {
      const k = a.getAttribute('data-lc-nav') || '';
      // Let the anchor navigate via hash so we can persist state
      setTimeout(() => activate(k), 0);
    });
  });

  tiles.forEach((t) => {
    t.addEventListener('click', () => {
      const k = t.getAttribute('data-lc-tile') || '';
      setTimeout(() => activate(k), 0);
    });
  });

  window.addEventListener('hashchange', () => activate(readHash()));

  // Initial state
  activate(readHash());
})();
